import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
const InitialSetupStep = ({ complete, description, href }) => {
    return (_jsxs("a", { className: "home-menu-item initial-setup-item", href: href, children: [complete
                ? _jsx(FontAwesomeIcon, { icon: faCircleCheck, size: "2x", className: "home-menu-icon-success" })
                : _jsx(FontAwesomeIcon, { icon: faCircle, size: "2x", className: "home-menu-icon-disabled" }), _jsx("h2", { children: description })] }));
};
export default InitialSetupStep;
